import * as React from 'react';

import { ComponentPropsWithoutStyles } from '@/util/ComponentPropsWithoutStyles';

import * as styles from './inputGroup.css';

export type InputGroupHelperMessageProps = {
  variant?: keyof typeof styles.message;
} & ComponentPropsWithoutStyles<React.HTMLAttributes<HTMLDivElement>>;

export const InputGroupHelperMessage: React.FC<InputGroupHelperMessageProps> = ({
  variant = 'default',
  children,
  ...props
}) => (
  <div className={styles.message[variant || 'default']} {...props}>
    {children}
  </div>
);
